<template>
  <ow0032026 :schema="schema" :applicant="applicant" :student="student" :school="school">
    <template slot="deviationsOrEvents">
      <panel title="WNOSZĘ O PRZYZNANIE POMOCY MATERIALNEJ O CHARAKTERZE SOCJALNYM, tj. STYPENDIUM SZKOLNEGO">
        <p>{{ schema.data.deviations.$title }}</p>

        <w-error :model="schema.data.deviations" />

        <template v-for="(item, index) in typeOfDeviations">
          <w-checkbox
            :key="index + '.deviations'"
            :model="schema.data.deviations"
            :value="item.value"
            :title="item.text"
            :show-error="false"
          />
        </template>

        <w-textarea v-if="randomEventsSelected" :model="schema.data.randomEvents" />
      </panel>
    </template>

    <template slot="support">
      <w-checkbox
        v-for="(type, index) of typeOfScholarshipForms"
        :key="'form_' + index"
        :model="schema.data.benefitForm"
        :title="type.text"
        :value="type.value"
      />
    </template>
  </ow0032026>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';

import Panel from '@/components/panel/Panel.vue';
import { ow003Mixin } from '@/mixins/document/ow003';
import { replacePlaceholdersMixin } from '@/mixins/replacePlaceholders';

import Ow0032026 from './OW-003-2026';

// @vuese
// OW-003 Stypendia
// @group templates
export default {
  components: { Ow0032026, Panel, ...components },
  mixins: [ow003Mixin, replacePlaceholdersMixin],
  props: {
    // schema dokumentu
    schema: { type: Object, required: true },
    // dane ucznia
    student: { type: Object, required: false },
    // dane wnioskodawcy
    applicant: { type: Object, required: false },
    // dane szkoły
    school: { type: Object, required: false }
  },
  computed: {
    isMoneySupportSelected() {
      return this.schema.$model.data.benefitForm.indexOf(1) >= 0;
    },
    isMatterialSupportSelected() {
      return this.schema.$model.data.benefitForm.indexOf(2) >= 0;
    }
  }
};
</script>
